import { combineReducers } from 'redux';
import themeReducer from './theme';
// import labelReducer from './label'

export default combineReducers({
    theme: themeReducer
    // label: labelReducer
});



// WEBPACK FOOTER //
// ./src/reducers/serviceHealth/index.js